import "./Button.scss";
import { Link } from "react-router-dom";
import Icon from "core/icon/Icon";
import PropTypes from "prop-types";

const TypeSwitch = ({ children, ...props }) => {
  const { linkTarget, type, ...rest } = props;
  return (
    <>
      {type === "link" ? (
        <Link id={props?.id} {...rest} target={linkTarget} replace>
          {children}
        </Link>
      ) : (
        <button id={props?.id} type={type} {...rest}>
          {children}
        </button>
      )}
    </>
  );
};

const Button = ({
  children,
  className,
  disabled,
  icon,
  linkTo,
  linkTarget,
  onClick,
  type,
  color,
  size,
  id,
  ...props
}) => {
  return (
    <TypeSwitch
      id={id}
      style={{
        backgroundColor: props.backgroundColor,
        cursor: disabled && "not-allowed",
        margin: props.margin,
      }}
      className={`btn${size ? " btn-common btn-" + size : ""}
      ${className} ${icon ? "icon btn-group" : ""}
      ${color || "deep-purple"}
      `}
      disabled={disabled}
      type={type}
      {...(type === "link" ? { to: linkTo, linkTarget, onClick } : { onClick })}
      {...props}
    >
      {children && <span> {children} </span>}
      {icon && (
        <Icon
          color={color || "deep-purple"}
          icon={icon}
          width={15}
          height={15}
        />
      )}
    </TypeSwitch>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  linkTo: PropTypes.string,
  linkTarget: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  id: PropTypes.string,
  backgroundColor: PropTypes.string,
  margin: PropTypes.string,
};

export default Button;
